import { isMobile } from 'react-device-detect';
import { Divider } from '@mui/material';

import {
    StyledArrowForwardIosRoundedIcon,
    StyledChatBarItem,
    StyledChatBarItemAvatar,
    StyledChatBarItemContent,
    StyledChatBarItemContentText,
    StyledChatBarItemNotification,
    StyledChatBarItemTitle,
} from './ChatBarItem.styled';
import LogoExample from 'assets/icons/LogoExample.png';

interface Props {
    newMessageCount?: string;
    lastMessage?: string;
    active?: boolean;
    title: string;
    avatar?: string;
    onClick: () => void;
}

export default function ChatBarItem(props: Props) {
    return (
        <div onClick={props.onClick}>
            <StyledChatBarItem active={props.active}>
                {props.avatar ? (
                    <StyledChatBarItemAvatar src={props.avatar} alt="" />
                ) : (
                    <StyledChatBarItemAvatar src={LogoExample} alt="" />
                )}
                <StyledChatBarItemContent>
                    <StyledChatBarItemTitle>{props.title}</StyledChatBarItemTitle>
                    {props.lastMessage && (
                        <StyledChatBarItemContentText>
                            {props.lastMessage}
                        </StyledChatBarItemContentText>
                    )}
                </StyledChatBarItemContent>
                {props.newMessageCount && (
                    <StyledChatBarItemNotification>
                        {props.newMessageCount}
                    </StyledChatBarItemNotification>
                )}
                {isMobile && <StyledArrowForwardIosRoundedIcon />}
            </StyledChatBarItem>
            <Divider variant="middle" />
        </div>
    );
}
